import { UseScriptOptions, UseScriptStatus } from "./useScript.domain"

export const getScriptNode = (src: string) => {
	const node: HTMLScriptElement | null = document.querySelector(
		`script[src="${src}"]`
	)
	const status = node?.getAttribute("data-status") as
		| UseScriptStatus
		| undefined

	return {
		node,
		status,
	}
}

export const getStatusFromEvent = (type: Event["type"]): UseScriptStatus =>
	type === "load" ? "ready" : "error"

export const isScriptFinished = (
	status: UseScriptStatus | undefined
): status is UseScriptStatus => status === "ready" || status === "error"

export const isScriptReady = (src: string, options?: UseScriptOptions) =>
	!src || options?.shouldPreventLoad

export const getStatusFromCacheOrDOM = (
	status?: UseScriptStatus,
	cache?: UseScriptStatus
) => status ?? cache ?? "loading"
